export default "__VITE_ASSET__BDN0ULV7__"